import React from 'react';
import { withRouter } from 'react-router-dom';
import {compose, withApollo, graphql} from 'react-apollo';
import {injectIntl} from 'react-intl';
import { message } from 'antd';
import moment from 'moment';
import URL from '../../utils/url';

import PageNotFound from '../../not-found';
import { Analytics } from "./index";
import AnalyticsMenu from "./menu";
import { Audit } from "./audit/index";
import GFM from "./gfm/index";
import Lead from "./lead-information";
import './analytics.css';
import DashboardLayout from "../layout/index";
import ProjectsFilter from "./projects-filter";
import {SAVE_PAGE_FILTERS} from "./gql/mutation";
import {Loading} from "../../utils/loading";
import {PAGE_FILTERS} from "./gql/query";

class AnalyticsRouter extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      dateFrom: '',
      dateTo: '',
      initialState: {
        'lead-age': {
          mode: null, //bar, line, pie
          unit: 'count', // count, percent
          showScore: false,
          scoringTypes: ['good'] // good, low, mid, high
        },
      }
    }
  }


  // state ~ {'leads': {mode: null, unit: 'count'}}
  setInitialState = newState =>
    this.setState(({initialState}) => ({initialState: {...initialState, ...newState}}))
    
  applyState(state) {
    const {pathname, search} = this._setUrlFromState(state);
    this.savePageFilters(pathname, search);
    if (pathname === '/dashboard/analytics') {
      this.savePageFilters('/dashboard/admin', search);
    } else if (pathname === '/dashboard/admin') {
      this.savePageFilters('/dashboard/analytics', search);
    }

    this.setState(state);
  }

  loadState({pathname, search}) {
    const { history } = this.props;
    if(search) {
      this.setState(this._parseStateFromUrl({pathname, search}));
      // this.savePageFilters(location.pathname, location.search)
    } else {
      this.loadPageFilters(pathname, (search) => {
        if (search) {
          history.replace({pathname, search});
        }
        this.setState(this._parseStateFromUrl({pathname, search}));
      })
    }
  }

  componentWillMount() {
    this.loadState(this.props.location);
  }

  loadPageFilters(page, thenCb) {
    this.props.client
      .query({query: PAGE_FILTERS, variables: {page}})
      .then(({data}) => {
        thenCb(data.pageFilters || '');
      }).catch(this.handleInternalError);
  }

  savePageFilters(page, search) {
    this.props
      .savePageFilters({
        variables: { page, filters: search },
        update: (proxy, { data: { savePageFilters } }) => {
          proxy.writeQuery({ query: PAGE_FILTERS, variables: { page }, data: {pageFilters: search} });
        }
      })
      .catch(this.handleInternalError)
  }

  handleInternalError = (err) => {
    const { formatMessage } = this.props.intl;
    message.error(formatMessage({id: 'general.network-error',
      defaultMessage: 'Network error, try again later'}));
  }

  /**
   * clear filter on analytics page change
   * @param prevProps
   */
  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.loadState(this.props.location);
    }
  }

  _parseStateFromUrl(location) {
    let {pathname, search} = location;
    pathname = pathname.replace(/\/$/, '');
    const data = URL.parseUrlParams(search);
    let { dateFrom, dateTo } = this._parsePeriodFromUrl(data, pathname);
    let metric = data && data.metric;
    metric = metric || this._getDefaultMetric(pathname);
    let groups = data && data.groups && data.groups.split(',');
    groups = groups || [];
    let osGroups = data && data.osGroups && data.osGroups.split(',');
    osGroups = osGroups || [];
    let browserGroups = data && data.browserGroups && data.browserGroups.split(',');
    browserGroups = browserGroups || [];
    let trafficChannels = data && data.trafficChannels && data.trafficChannels.split(',');
    trafficChannels = trafficChannels || [];
    let affiliateNetworks = data && data.affiliateNetworks && data.affiliateNetworks.split(',');
    affiliateNetworks = affiliateNetworks || [];
    let deviceTypes = data && data.deviceTypes && data.deviceTypes.split(',');
    deviceTypes = deviceTypes || [];
    let country = data && (parseInt(data.country) || undefined);
    let region = data && data.region && data.region.split(',');
    let cities = data && data.cities && data.cities.split(',');
    region = region || [];
    cities = cities || [];
    let labelType = data && data.labelType;
    labelType = labelType || undefined;
    let labelValues = data && data.labelValues;
    if (labelValues) {
      try {
        labelValues = JSON.parse(labelValues)
      } catch (e) {}
    }
    labelValues = labelValues || {};
    let projects = data && data.projects && data.projects.split(',');
    projects = projects || [];
    let pageSize = data && data.pageSize;
    let currentPage = data && data.currentPage;
    let order = data && data.order;
    
    return {
      pathname, dateFrom, dateTo, metric, groups,
      labelType, labelValues, projects, osGroups,
      browserGroups, trafficChannels, affiliateNetworks, deviceTypes, country, cities,
      pageSize, currentPage, order, region
    }
  }

  /**
   * @param data
   * @return {{dateFrom: moment, dateTo: moment}}
   * @private
   */
  _parsePeriodFromUrl(data, pathname) {
    let dateFrom = this.state.dateFrom || URL.parseDate(data && data.dateFrom);
    let dateTo = this.state.dateTo || URL.parseDate(data && data.dateTo);
    if (!dateFrom || !dateTo) {
      const period = this._getDefaultPeriod(pathname);
      dateFrom = period.dateFrom;
      dateTo = period.dateTo;
    }
    dateTo = dateTo.endOf('day')
    return {dateFrom, dateTo};
  }

  _getDefaultPeriod(pathname) {
    if( pathname.indexOf('audit') === -1) {
      return {dateFrom: moment.utc().add(-2, 'month'), dateTo: moment.utc()};
    } else {
      return {dateFrom: moment.utc().add(-1, 'month'), dateTo: moment.utc()};
    }
  }

  _getDefaultMetric(pathname) {
    if( pathname.indexOf('audit') === -1) {
      return 'lead-age';
    } else {
      return 'consumer-origin';
    }
  }

  /**
   * apply state diff to location search params
   * @param state {object}
   * @private
   */
  _setUrlFromState(state) {
    const { location, history } = this.props;
    let search = URL.setUrlParams(location.search, (data) => {
      'dateFrom' in state && URL.setUrlDateParam(data, 'dateFrom', state.dateFrom);
      'dateTo' in state && URL.setUrlDateParam(data, 'dateTo', state.dateTo);
      'metric' in state && URL.setUrlStringParam(data, 'metric', state.metric);
      'groups' in state && URL.setUrlArrayParam(data, 'groups', state.groups);
      'osGroups' in state && URL.setUrlArrayParam(data, 'osGroups', state.osGroups);
      'browserGroups' in state && URL.setUrlArrayParam(data, 'browserGroups', state.browserGroups);
      'trafficChannels' in state && URL.setUrlArrayParam(data, 'trafficChannels', state.trafficChannels);
      'affiliateNetworks' in state && URL.setUrlArrayParam(data, 'affiliateNetworks', state.affiliateNetworks);
      'deviceTypes' in state && URL.setUrlArrayParam(data, 'deviceTypes', state.deviceTypes);
      'country' in state && URL.setUrlStringParam(data, 'country', state.country);
      'region' in state && URL.setUrlArrayParam(data, 'region', state.region);
      'cities' in state && URL.setUrlArrayParam(data, 'cities', state.cities);
      'labelType' in state && URL.setUrlStringParam(data, 'labelType', state.labelType);
      'labelValues' in state && URL.setUrlObjectParam(data, 'labelValues', state.labelValues);
      'projects' in state && URL.setUrlArrayParam(data, 'projects', state.projects);
      'pageSize' in state && URL.setUrlStringParam(data, 'pageSize', state.pageSize);
      'currentPage' in state && URL.setUrlStringParam(data, 'currentPage', state.currentPage);
      'order' in state && URL.setUrlStringParam(data, 'order', state.order);
       return data;
    });
    history.push({ pathname: location.pathname, search });
    return {pathname: location.pathname, search}
  }

  onPeriodChange = (date) => {
    this.applyState({dateFrom: date[0], dateTo: date[1], currentPage: 1})
  }

  onMetricChange = (metric) => {
    this.applyState({metric, groups: [], currentPage: 1});
  }

  onLeadGroupsChange = (groups) => {
    this.applyState({groups, currentPage: 1});
  }
  onOsGroupsChange = (osGroups) => {
    this.applyState({osGroups, currentPage: 1});
  }

  onBrowserGroupsChange = (browserGroups) => {
    this.applyState({browserGroups, currentPage: 1})
  }

  onTrafficChannelsChange = (trafficChannels) => {
    this.applyState({trafficChannels, currentPage: 1})
  }

  onAffiliateNetworksChange = (affiliateNetworks) => {
    this.applyState({affiliateNetworks, currentPage: 1})
  }

  onDeviceTypesChange = (deviceTypes) => {
    this.applyState({deviceTypes, currentPage: 1})
  }

  onCountryChange = (country) => {
    this.applyState({country, region: [], cities: [], currentPage: 1})
  }

  onRegionChange = (region) => {
    this.applyState({region, cities: [], currentPage: 1})
  }

  onCitiesChange = (cities) => {
    this.applyState({cities, currentPage: 1})
  }

  onUrlLabelsChange = (labelType, labelValues) => {
    this.applyState({labelType, labelValues, currentPage: 1});
  }

  onProjectsChange = (projects) => {
    this.applyState({projects, currentPage: 1});
  }

  onTableChange = (pagination, filters, sorter) => {
    const pageSize = pagination.pageSize;
    const currentPage = pagination.current;
    let state = {pageSize, currentPage};
    
    if (sorter) {
         state.order = sorter.field && (sorter.order === 'descend' ? '-' : '') + sorter.field;
    }
    this.applyState(state);
  }

  renderChildren() {
    const { pathname } = this.state;
    
    if (!pathname) {
      return <Loading/>
    }

    switch (pathname.replace(/\/$/, '')) {
      case '/dashboard/analytics': 
        return (<Analytics
            {...this.state}
            setInitialState={this.setInitialState}
            onPeriodChange={this.onPeriodChange}
            onMetricChange={this.onMetricChange}
            onLeadGroupsChange={this.onLeadGroupsChange}
            onOsGroupsChange={this.onOsGroupsChange}
            onBrowserGroupsChange={this.onBrowserGroupsChange}
            onTrafficChannelsChange={this.onTrafficChannelsChange}
            onAffiliateNetworksChange={this.onAffiliateNetworksChange}
            onDeviceTypesChange={this.onDeviceTypesChange}
            onCountryChange={this.onCountryChange}
            onRegionChange={this.onRegionChange}
            onCitiesChange={this.onCitiesChange}
            onUrlLabelsChange={this.onUrlLabelsChange}
            onTableChange={this.onTableChange}
          /> )
    case '/dashboard/analytics/audit':
      return ( <Audit
          {...this.state}
          setInitialState={this.setInitialState}
          onPeriodChange={this.onPeriodChange}
          onMetricChange={this.onMetricChange}
          onLeadGroupsChange={this.onLeadGroupsChange}
          onOsGroupsChange={this.onOsGroupsChange}
          onBrowserGroupsChange={this.onBrowserGroupsChange}
          onTrafficChannelsChange={this.onTrafficChannelsChange}
          onAffiliateNetworksChange={this.onAffiliateNetworksChange}
          onDeviceTypesChange={this.onDeviceTypesChange}
          onCountryChange={this.onCountryChange}
          onRegionChange={this.onRegionChange}
          onCitiesChange={this.onCitiesChange}
          onUrlLabelsChange={this.onUrlLabelsChange}
        /> )
    case '/dashboard/analytics/gfm':
      return ( <GFM
          {...this.state}
          setInitialState={this.setInitialState}
          onPeriodChange={this.onPeriodChange}
          onMetricChange={this.onMetricChange}
          onLeadGroupsChange={this.onLeadGroupsChange}
          onOsGroupsChange={this.onOsGroupsChange}
          onBrowserGroupsChange={this.onBrowserGroupsChange}
          onTrafficChannelsChange={this.onTrafficChannelsChange}
          onAffiliateNetworksChange={this.onAffiliateNetworksChange}
          onDeviceTypesChange={this.onDeviceTypesChange}
          onCountryChange={this.onCountryChange}
          onRegionChange={this.onRegionChange}
          onCitiesChange={this.onCitiesChange}
          onUrlLabelsChange={this.onUrlLabelsChange}
        /> )
    case '/dashboard/analytics/lead':
      return <Lead/>
    default:
      return <PageNotFound/>
    }
  }

  render() {
    const { projects } = this.state;
    return (
      <DashboardLayout
        beforeContentCmp={<AnalyticsMenu />}
        extSiderCmp={<ProjectsFilter checked={projects} onChange={this.onProjectsChange} />}
      >
        {this.renderChildren()}
      </DashboardLayout>
    )
  }
}


export default compose(
  withApollo,
  graphql(SAVE_PAGE_FILTERS, {
    name: 'savePageFilters'
  })
)(withRouter(injectIntl(AnalyticsRouter)));


// WEBPACK FOOTER //
// ./src/components/dashboard/analytics/routing.js